import React from 'react';
import Countdown from 'react-countdown';
import '../styles/style.css'

export class CountDownTimer extends React.Component {
    constructor() {
        super()
        this.state = {
            completions: 0
        }
    }
    
    onComplete = () => {
        this.setState( 
            {
                completions: this.state.completions + 1
            },
        )
    }
    
    renderer ({ minutes, seconds, completed }) {
        if (completed) {
            return ((
                <div>
                  <h6 className="text-secondary">Auto refreshing now</h6>;
                </div>
            ))
        } else {
            return ((
                <div>
                    <h6 className="text-secondary">Auto refreshing in {minutes} minute {seconds} seconds</h6>
                </div>
            ))
        }
    }    
    
    render() {
        return (
            <div>
                <Countdown
                key={this.state.completions}
                date={Date.now() + 300000}
                renderer={this.renderer}
                onComplete={this.onComplete}
                />
            </div>
        )
    }
};